import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH.
 * Emergent OAuth returns session_id in the URL fragment. We exchange it once, set a cookie
 * on the backend, then redirect the user to their dashboard.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();

  useEffect(() => {
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) { navigate("/login", { replace: true }); return; }

    let done = false;
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", null, {
          headers: { "X-Session-ID": sessionId },
        });
        if (done) return;
        setUser(data);
        const target = data.role === "admin" ? "/admin" : "/portal";
        window.history.replaceState({}, "", window.location.pathname);
        navigate(target, { replace: true, state: { user: data } });
      } catch (_) {
        navigate("/login?error=oauth", { replace: true });
      }
    })();

    return () => { done = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="glass rounded-2xl p-8 text-center">
        <div className="mx-auto h-10 w-10 rounded-full border-2 border-primary/30 border-t-primary animate-spin mb-4" />
        <div className="text-sm text-muted-foreground">Signing you in with Google…</div>
      </div>
    </div>
  );
}
